export const VERIFIED_EVENTS_METHODOLOGY_LABEL =
  "Verified Events Methodology and Definitions";
